<template>
  <slot><span class="text-red-600">*</span></slot>
</template>

<script setup></script>
